/* ------------------------------------------------------------
   Vault currency sync & converter + Ultra-Fast Instant Switcher
   ------------------------------------------------------------
   Eliminates page reload latency on currency selection.
   Updates prices, exchange rates, flags, and text instantly (<10ms)
   without server reloads. Caches live rates in localStorage.
   ------------------------------------------------------------ */
(function () {
  'use strict';

  var VAULT_ALL_COUNTRIES = [{"code": "PK", "currency": "PKR", "symbol": "Rs. ", "name": "Pakistan", "flag": "🇵🇰", "note": "Cash on Delivery Available"}, {"code": "US", "currency": "USD", "symbol": "$", "name": "United States", "flag": "🇺🇸", "note": "US Dollar"}, {"code": "GB", "currency": "GBP", "symbol": "£", "name": "United Kingdom", "flag": "🇬🇧", "note": "British Pound"}, {"code": "AF", "currency": "AFN", "symbol": "؋ ", "name": "Afghanistan", "flag": "🇦🇫", "note": "Afghan Afghani"}, {"code": "AL", "currency": "ALL", "symbol": "Lek ", "name": "Albania", "flag": "🇦🇱", "note": "Albanian Lek"}, {"code": "DZ", "currency": "DZD", "symbol": "DZD ", "name": "Algeria", "flag": "🇩🇿", "note": "Algerian Dinar"}, {"code": "AD", "currency": "EUR", "symbol": "€", "name": "Andorra", "flag": "🇦🇩", "note": "Euro"}, {"code": "AO", "currency": "AOA", "symbol": "Kz ", "name": "Angola", "flag": "🇦🇴", "note": "Angolan Kwanza"}, {"code": "AG", "currency": "XCD", "symbol": "EC$ ", "name": "Antigua & Barbuda", "flag": "🇦🇬", "note": "East Caribbean Dollar"}, {"code": "AR", "currency": "ARS", "symbol": "$", "name": "Argentina", "flag": "🇦🇷", "note": "Argentine Peso"}, {"code": "AM", "currency": "AMD", "symbol": "֏ ", "name": "Armenia", "flag": "🇦🇲", "note": "Armenian Dram"}, {"code": "AU", "currency": "AUD", "symbol": "A$ ", "name": "Australia", "flag": "🇦🇺", "note": "Australian Dollar"}, {"code": "AT", "currency": "EUR", "symbol": "€", "name": "Austria", "flag": "🇦🇹", "note": "Euro"}, {"code": "AZ", "currency": "AZN", "symbol": "₼ ", "name": "Azerbaijan", "flag": "🇦🇿", "note": "Azerbaijani Manat"}, {"code": "BS", "currency": "BSD", "symbol": "B$ ", "name": "Bahamas", "flag": "🇧🇸", "note": "Bahamian Dollar"}, {"code": "BH", "currency": "BHD", "symbol": "BHD ", "name": "Bahrain", "flag": "🇧🇭", "note": "Bahraini Dinar"}, {"code": "BD", "currency": "BDT", "symbol": "৳ ", "name": "Bangladesh", "flag": "🇧🇩", "note": "Bangladeshi Taka"}, {"code": "BB", "currency": "BBD", "symbol": "Bds$ ", "name": "Barbados", "flag": "🇧🇧", "note": "Barbadian Dollar"}, {"code": "BY", "currency": "BYN", "symbol": "Br ", "name": "Belarus", "flag": "🇧🇾", "note": "Belarusian Ruble"}, {"code": "BE", "currency": "EUR", "symbol": "€", "name": "Belgium", "flag": "🇧🇪", "note": "Euro"}, {"code": "BZ", "currency": "BZD", "symbol": "BZ$ ", "name": "Belize", "flag": "🇧🇿", "note": "Belize Dollar"}, {"code": "BJ", "currency": "XOF", "symbol": "CFA ", "name": "Benin", "flag": "🇧🇯", "note": "West African CFA franc"}, {"code": "BT", "currency": "BTN", "symbol": "Nu. ", "name": "Bhutan", "flag": "🇧🇹", "note": "Bhutanese Ngultrum"}, {"code": "BO", "currency": "BOB", "symbol": "Bs. ", "name": "Bolivia", "flag": "🇧🇴", "note": "Bolivian Boliviano"}, {"code": "BA", "currency": "BAM", "symbol": "KM ", "name": "Bosnia & Herzegovina", "flag": "🇧🇦", "note": "Convertible Mark"}, {"code": "BW", "currency": "BWP", "symbol": "P ", "name": "Botswana", "flag": "🇧🇼", "note": "Botswana Pula"}, {"code": "BR", "currency": "BRL", "symbol": "R$ ", "name": "Brazil", "flag": "🇧🇷", "note": "Brazilian Real"}, {"code": "BN", "currency": "BND", "symbol": "B$ ", "name": "Brunei", "flag": "🇧🇳", "note": "Brunei Dollar"}, {"code": "BG", "currency": "BGN", "symbol": "лв ", "name": "Bulgaria", "flag": "🇧🇬", "note": "Bulgarian Lev"}, {"code": "BF", "currency": "XOF", "symbol": "CFA ", "name": "Burkina Faso", "flag": "🇧🇫", "note": "West African CFA franc"}, {"code": "BI", "currency": "BIF", "symbol": "FBu ", "name": "Burundi", "flag": "🇧🇮", "note": "Burundian Franc"}, {"code": "KH", "currency": "KHR", "symbol": "៛ ", "name": "Cambodia", "flag": "🇰🇭", "note": "Cambodian Riel"}, {"code": "CM", "currency": "XAF", "symbol": "FCFA ", "name": "Cameroon", "flag": "🇨🇲", "note": "Central African CFA franc"}, {"code": "CA", "currency": "CAD", "symbol": "C$ ", "name": "Canada", "flag": "🇨🇦", "note": "Canadian Dollar"}, {"code": "CV", "currency": "CVE", "symbol": "$ ", "name": "Cape Verde", "flag": "🇨🇻", "note": "Cape Verdean Escudo"}, {"code": "KY", "currency": "KYD", "symbol": "CI$ ", "name": "Cayman Islands", "flag": "🇰🇾", "note": "Cayman Islands Dollar"}, {"code": "CL", "currency": "CLP", "symbol": "$ ", "name": "Chile", "flag": "🇨🇱", "note": "Chilean Peso"}, {"code": "CN", "currency": "CNY", "symbol": "¥ ", "name": "China", "flag": "🇨🇳", "note": "Chinese Yuan"}, {"code": "CO", "currency": "COP", "symbol": "$ ", "name": "Colombia", "flag": "🇨🇴", "note": "Colombian Peso"}, {"code": "CR", "currency": "CRC", "symbol": "₡ ", "name": "Costa Rica", "flag": "🇨🇷", "note": "Costa Rican Colón"}, {"code": "HR", "currency": "EUR", "symbol": "€", "name": "Croatia", "flag": "🇭🇷", "note": "Euro"}, {"code": "CY", "currency": "EUR", "symbol": "€", "name": "Cyprus", "flag": "🇨🇾", "note": "Euro"}, {"code": "CZ", "currency": "CZK", "symbol": "Kč ", "name": "Czech Republic", "flag": "🇨🇿", "note": "Czech Koruna"}, {"code": "DK", "currency": "DKK", "symbol": "kr ", "name": "Denmark", "flag": "🇩🇰", "note": "Danish Krone"}, {"code": "DJ", "currency": "DJF", "symbol": "Fdj ", "name": "Djibouti", "flag": "🇩🇯", "note": "Djiboutian Franc"}, {"code": "DO", "currency": "DOP", "symbol": "RD$ ", "name": "Dominican Republic", "flag": "🇩🇴", "note": "Dominican Peso"}, {"code": "EC", "currency": "USD", "symbol": "$", "name": "Ecuador", "flag": "🇪🇨", "note": "US Dollar"}, {"code": "EG", "currency": "EGP", "symbol": "EGP ", "name": "Egypt", "flag": "🇪🇬", "note": "Egyptian Pound"}, {"code": "SV", "currency": "USD", "symbol": "$", "name": "El Salvador", "flag": "🇸🇻", "note": "US Dollar"}, {"code": "EE", "currency": "EUR", "symbol": "€", "name": "Estonia", "flag": "🇪🇪", "note": "Euro"}, {"code": "ET", "currency": "ETB", "symbol": "Br ", "name": "Ethiopia", "flag": "🇪🇹", "note": "Ethiopian Birr"}, {"code": "FJ", "currency": "FJD", "symbol": "FJ$ ", "name": "Fiji", "flag": "🇫🇯", "note": "Fijian Dollar"}, {"code": "FI", "currency": "EUR", "symbol": "€", "name": "Finland", "flag": "🇫🇮", "note": "Euro"}, {"code": "FR", "currency": "EUR", "symbol": "€", "name": "France", "flag": "🇫🇷", "note": "Euro"}, {"code": "GA", "currency": "XAF", "symbol": "FCFA ", "name": "Gabon", "flag": "🇬🇦", "note": "Central African CFA franc"}, {"code": "GM", "currency": "GMD", "symbol": "D ", "name": "Gambia", "flag": "🇬🇲", "note": "Gambian Dalasi"}, {"code": "GE", "currency": "GEL", "symbol": "₾ ", "name": "Georgia", "flag": "🇬🇪", "note": "Georgian Lari"}, {"code": "DE", "currency": "EUR", "symbol": "€", "name": "Germany", "flag": "🇩🇪", "note": "Euro"}, {"code": "GH", "currency": "GHS", "symbol": "GH₵ ", "name": "Ghana", "flag": "🇬🇭", "note": "Ghanaian Cedi"}, {"code": "GR", "currency": "EUR", "symbol": "€", "name": "Greece", "flag": "🇬🇷", "note": "Euro"}, {"code": "GD", "currency": "XCD", "symbol": "EC$ ", "name": "Grenada", "flag": "🇬🇩", "note": "East Caribbean Dollar"}, {"code": "GT", "currency": "GTQ", "symbol": "Q ", "name": "Guatemala", "flag": "🇬🇹", "note": "Guatemalan Quetzal"}, {"code": "GN", "currency": "GNF", "symbol": "FG ", "name": "Guinea", "flag": "🇬🇳", "note": "Guinean Franc"}, {"code": "GY", "currency": "GYD", "symbol": "G$ ", "name": "Guyana", "flag": "🇬🇾", "note": "Guyanese Dollar"}, {"code": "HT", "currency": "HTG", "symbol": "G ", "name": "Haiti", "flag": "🇭🇹", "note": "Haitian Gourde"}, {"code": "HN", "currency": "HNL", "symbol": "L ", "name": "Honduras", "flag": "🇭🇳", "note": "Honduran Lempira"}, {"code": "HK", "currency": "HKD", "symbol": "HK$ ", "name": "Hong Kong", "flag": "🇭🇰", "note": "Hong Kong Dollar"}, {"code": "HU", "currency": "HUF", "symbol": "Ft ", "name": "Hungary", "flag": "🇭🇺", "note": "Hungarian Forint"}, {"code": "IS", "currency": "ISK", "symbol": "kr ", "name": "Iceland", "flag": "🇮🇸", "note": "Icelandic Króna"}, {"code": "IN", "currency": "INR", "symbol": "₹ ", "name": "India", "flag": "🇮🇳", "note": "Indian Rupee"}, {"code": "ID", "currency": "IDR", "symbol": "Rp ", "name": "Indonesia", "flag": "🇮🇩", "note": "Indonesian Rupiah"}, {"code": "IQ", "currency": "IQD", "symbol": "IQD ", "name": "Iraq", "flag": "🇮🇶", "note": "Iraqi Dinar"}, {"code": "IE", "currency": "EUR", "symbol": "€", "name": "Ireland", "flag": "🇮🇪", "note": "Euro"}, {"code": "IL", "currency": "ILS", "symbol": "₪ ", "name": "Israel", "flag": "🇮🇱", "note": "Israeli New Shekel"}, {"code": "IT", "currency": "EUR", "symbol": "€", "name": "Italy", "flag": "🇮🇹", "note": "Euro"}, {"code": "JM", "currency": "JMD", "symbol": "J$ ", "name": "Jamaica", "flag": "🇯🇲", "note": "Jamaican Dollar"}, {"code": "JP", "currency": "JPY", "symbol": "¥ ", "name": "Japan", "flag": "🇯🇵", "note": "Japanese Yen"}, {"code": "JO", "currency": "JOD", "symbol": "JOD ", "name": "Jordan", "flag": "🇯🇴", "note": "Jordanian Dinar"}, {"code": "KZ", "currency": "KZT", "symbol": "₸ ", "name": "Kazakhstan", "flag": "🇰🇿", "note": "Kazakhstani Tenge"}, {"code": "KE", "currency": "KES", "symbol": "KSh ", "name": "Kenya", "flag": "🇰🇪", "note": "Kenyan Shilling"}, {"code": "KR", "currency": "KRW", "symbol": "₩ ", "name": "South Korea", "flag": "🇰🇷", "note": "South Korean Won"}, {"code": "KW", "currency": "KWD", "symbol": "KWD ", "name": "Kuwait", "flag": "🇰🇼", "note": "Kuwaiti Dinar"}, {"code": "KG", "currency": "KGS", "symbol": "с ", "name": "Kyrgyzstan", "flag": "🇰🇬", "note": "Kyrgyzstani Som"}, {"code": "LA", "currency": "LAK", "symbol": "₭ ", "name": "Laos", "flag": "🇱🇦", "note": "Lao Kip"}, {"code": "LV", "currency": "EUR", "symbol": "€", "name": "Latvia", "flag": "🇱🇻", "note": "Euro"}, {"code": "LB", "currency": "LBP", "symbol": "L£ ", "name": "Lebanon", "flag": "🇱🇧", "note": "Lebanese Pound"}, {"code": "LS", "currency": "LSL", "symbol": "L ", "name": "Lesotho", "flag": "🇱🇸", "note": "Lesotho Loti"}, {"code": "LR", "currency": "LRD", "symbol": "L$ ", "name": "Liberia", "flag": "🇱🇷", "note": "Liberian Dollar"}, {"code": "LY", "currency": "LYD", "symbol": "LD ", "name": "Libya", "flag": "🇱🇾", "note": "Libyan Dinar"}, {"code": "LI", "currency": "CHF", "symbol": "CHF ", "name": "Liechtenstein", "flag": "🇱🇮", "note": "Swiss Franc"}, {"code": "LT", "currency": "EUR", "symbol": "€", "name": "Lithuania", "flag": "🇱🇹", "note": "Euro"}, {"code": "LU", "currency": "EUR", "symbol": "€", "name": "Luxembourg", "flag": "🇱🇺", "note": "Euro"}, {"code": "MO", "currency": "MOP", "symbol": "MOP$ ", "name": "Macau", "flag": "🇲🇴", "note": "Macanese Pataca"}, {"code": "MK", "currency": "MKD", "symbol": "ден ", "name": "North Macedonia", "flag": "🇲🇰", "note": "Macedonian Denar"}, {"code": "MG", "currency": "MGA", "symbol": "Ar ", "name": "Madagascar", "flag": "🇲🇬", "note": "Malagasy Ariary"}, {"code": "MW", "currency": "MWK", "symbol": "MK ", "name": "Malawi", "flag": "🇲🇼", "note": "Malawian Kwacha"}, {"code": "MY", "currency": "MYR", "symbol": "RM ", "name": "Malaysia", "flag": "🇲🇾", "note": "Malaysian Ringgit"}, {"code": "MV", "currency": "MVR", "symbol": "Rf ", "name": "Maldives", "flag": "🇲🇻", "note": "Maldivian Rufiyaa"}, {"code": "ML", "currency": "XOF", "symbol": "CFA ", "name": "Mali", "flag": "🇲🇱", "note": "West African CFA franc"}, {"code": "MT", "currency": "EUR", "symbol": "€", "name": "Malta", "flag": "🇲🇹", "note": "Euro"}, {"code": "MR", "currency": "MRU", "symbol": "UM ", "name": "Mauritania", "flag": "🇲🇷", "note": "Mauritanian Ouguiya"}, {"code": "MU", "currency": "MUR", "symbol": "₨ ", "name": "Mauritius", "flag": "🇲🇺", "note": "Mauritian Rupee"}, {"code": "MX", "currency": "MXN", "symbol": "Mex$ ", "name": "Mexico", "flag": "🇲🇽", "note": "Mexican Peso"}, {"code": "MD", "currency": "MDL", "symbol": "L ", "name": "Moldova", "flag": "🇲🇩", "note": "Moldovan Leu"}, {"code": "MC", "currency": "EUR", "symbol": "€", "name": "Monaco", "flag": "🇲🇨", "note": "Euro"}, {"code": "MN", "currency": "MNT", "symbol": "₮ ", "name": "Mongolia", "flag": "🇲🇳", "note": "Mongolian Tögrög"}, {"code": "ME", "currency": "EUR", "symbol": "€", "name": "Montenegro", "flag": "🇲🇪", "note": "Euro"}, {"code": "MA", "currency": "MAD", "symbol": "MAD ", "name": "Morocco", "flag": "🇲🇦", "note": "Moroccan Dirham"}, {"code": "MZ", "currency": "MZN", "symbol": "MT ", "name": "Mozambique", "flag": "🇲🇿", "note": "Mozambican Metical"}, {"code": "MM", "currency": "MMK", "symbol": "K ", "name": "Myanmar", "flag": "🇲🇲", "note": "Myanmar Kyat"}, {"code": "NA", "currency": "NAD", "symbol": "N$ ", "name": "Namibia", "flag": "🇳🇦", "note": "Namibian Dollar"}, {"code": "NP", "currency": "NPR", "symbol": "रू ", "name": "Nepal", "flag": "🇳🇵", "note": "Nepalese Rupee"}, {"code": "NL", "currency": "EUR", "symbol": "€", "name": "Netherlands", "flag": "🇳🇱", "note": "Euro"}, {"code": "NZ", "currency": "NZD", "symbol": "NZ$ ", "name": "New Zealand", "flag": "🇳🇿", "note": "New Zealand Dollar"}, {"code": "NI", "currency": "NIO", "symbol": "C$ ", "name": "Nicaragua", "flag": "🇳🇮", "note": "Nicaraguan Córdoba"}, {"code": "NE", "currency": "XOF", "symbol": "CFA ", "name": "Niger", "flag": "🇳🇪", "note": "West African CFA franc"}, {"code": "NG", "currency": "NGN", "symbol": "₦ ", "name": "Nigeria", "flag": "🇳🇬", "note": "Nigerian Naira"}, {"code": "NO", "currency": "NOK", "symbol": "kr ", "name": "Norway", "flag": "🇳🇴", "note": "Norwegian Krone"}, {"code": "OM", "currency": "OMR", "symbol": "OMR ", "name": "Oman", "flag": "🇴🇲", "note": "Omani Rial"}, {"code": "PA", "currency": "PAB", "symbol": "B/. ", "name": "Panama", "flag": "🇵🇦", "note": "Panamanian Balboa"}, {"code": "PG", "currency": "PGK", "symbol": "K ", "name": "Papua New Guinea", "flag": "🇵🇬", "note": "Papua New Guinean Kina"}, {"code": "PY", "currency": "PYG", "symbol": "₲ ", "name": "Paraguay", "flag": "🇵🇾", "note": "Paraguayan Guaraní"}, {"code": "PE", "currency": "PEN", "symbol": "S/. ", "name": "Peru", "flag": "🇵🇪", "note": "Peruvian Sol"}, {"code": "PH", "currency": "PHP", "symbol": "₱ ", "name": "Philippines", "flag": "🇵🇭", "note": "Philippine Peso"}, {"code": "PL", "currency": "PLN", "symbol": "zł ", "name": "Poland", "flag": "🇵🇱", "note": "Polish Złoty"}, {"code": "PT", "currency": "EUR", "symbol": "€", "name": "Portugal", "flag": "🇵🇹", "note": "Euro"}, {"code": "QA", "currency": "QAR", "symbol": "QR ", "name": "Qatar", "flag": "🇶🇦", "note": "Qatari Riyal"}, {"code": "RO", "currency": "RON", "symbol": "lei ", "name": "Romania", "flag": "🇷🇴", "note": "Romanian Leu"}, {"code": "RU", "currency": "RUB", "symbol": "₽ ", "name": "Russia", "flag": "🇷🇺", "note": "Russian Ruble"}, {"code": "RW", "currency": "RWF", "symbol": "FRw ", "name": "Rwanda", "flag": "🇷🇼", "note": "Rwandan Franc"}, {"code": "SA", "currency": "SAR", "symbol": "SR ", "name": "Saudi Arabia", "flag": "🇸🇦", "note": "Saudi Riyal"}, {"code": "SN", "currency": "XOF", "symbol": "CFA ", "name": "Senegal", "flag": "🇸🇳", "note": "West African CFA franc"}, {"code": "RS", "currency": "RSD", "symbol": "din. ", "name": "Serbia", "flag": "🇷🇸", "note": "Serbian Dinar"}, {"code": "SG", "currency": "SGD", "symbol": "S$ ", "name": "Singapore", "flag": "🇸🇬", "note": "Singapore Dollar"}, {"code": "SK", "currency": "EUR", "symbol": "€", "name": "Slovakia", "flag": "🇸🇰", "note": "Euro"}, {"code": "SI", "currency": "EUR", "symbol": "€", "name": "Slovenia", "flag": "🇸🇮", "note": "Euro"}, {"code": "ZA", "currency": "ZAR", "symbol": "R ", "name": "South Africa", "flag": "🇿🇦", "note": "South African Rand"}, {"code": "ES", "currency": "EUR", "symbol": "€", "name": "Spain", "flag": "🇪🇸", "note": "Euro"}, {"code": "LK", "currency": "LKR", "symbol": "Rs ", "name": "Sri Lanka", "flag": "🇱🇰", "note": "Sri Lankan Rupee"}, {"code": "SE", "currency": "SEK", "symbol": "kr ", "name": "Sweden", "flag": "🇸🇪", "note": "Swedish Krona"}, {"code": "CH", "currency": "CHF", "symbol": "CHF ", "name": "Switzerland", "flag": "🇨🇭", "note": "Swiss Franc"}, {"code": "TW", "currency": "TWD", "symbol": "NT$ ", "name": "Taiwan", "flag": "🇹🇼", "note": "New Taiwan Dollar"}, {"code": "TZ", "currency": "TZS", "symbol": "TSh ", "name": "Tanzania", "flag": "🇹🇿", "note": "Tanzanian Shilling"}, {"code": "TH", "currency": "THB", "symbol": "฿ ", "name": "Thailand", "flag": "🇹🇭", "note": "Thai Baht"}, {"code": "TT", "currency": "TTD", "symbol": "TT$ ", "name": "Trinidad & Tobago", "flag": "🇹🇹", "note": "Trinidad & Tobago Dollar"}, {"code": "TN", "currency": "TND", "symbol": "DT ", "name": "Tunisia", "flag": "🇹🇳", "note": "Tunisian Dinar"}, {"code": "TR", "currency": "TRY", "symbol": "₺ ", "name": "Turkey", "flag": "🇹🇷", "note": "Turkish Lira"}, {"code": "UG", "currency": "UGX", "symbol": "USh ", "name": "Uganda", "flag": "🇺🇬", "note": "Ugandan Shilling"}, {"code": "UA", "currency": "UAH", "symbol": "₴ ", "name": "Ukraine", "flag": "🇺🇦", "note": "Ukrainian Hryvnia"}, {"code": "AE", "currency": "AED", "symbol": "AED ", "name": "United Arab Emirates", "flag": "🇦🇪", "note": "UAE Dirham"}, {"code": "UY", "currency": "UYU", "symbol": "$U ", "name": "Uruguay", "flag": "🇺🇾", "note": "Uruguayan Peso"}, {"code": "UZ", "currency": "UZS", "symbol": "so'm ", "name": "Uzbekistan", "flag": "🇺🇿", "note": "Uzbekistani Soʻm"}, {"code": "VN", "currency": "VND", "symbol": "₫ ", "name": "Vietnam", "flag": "🇻🇳", "note": "Vietnamese Đồng"}, {"code": "ZM", "currency": "ZMW", "symbol": "ZK ", "name": "Zambia", "flag": "🇿🇲", "note": "Zambian Kwacha"}, {"code": "ZW", "currency": "ZWG", "symbol": "ZiG ", "name": "Zimbabwe", "flag": "🇿🇼", "note": "Zimbabwe Gold"}];
  var STORAGE_KEY = 'vault:country';
  var RATES_CACHE_KEY = 'vault:rates_cache';
  var RATES_CACHE_TIME_KEY = 'vault:rates_time';
  var CACHE_TTL_MS = 3600000; // 1 hour rate cache

  var COUNTRY_CURRENCY_MAP = {
    'PK': { code: 'PKR', symbol: 'Rs. ' },
    'US': { code: 'USD', symbol: '$' },
    'GB': { code: 'GBP', symbol: '£' },
    'AF': { code: 'AFN', symbol: '؋ ' },
    'AL': { code: 'ALL', symbol: 'Lek ' },
    'DZ': { code: 'DZD', symbol: 'DZD ' },
    'AD': { code: 'EUR', symbol: '€' },
    'AO': { code: 'AOA', symbol: 'Kz ' },
    'AG': { code: 'XCD', symbol: 'EC$ ' },
    'AR': { code: 'ARS', symbol: '$' },
    'AM': { code: 'AMD', symbol: '֏ ' },
    'AU': { code: 'AUD', symbol: 'A$ ' },
    'AT': { code: 'EUR', symbol: '€' },
    'AZ': { code: 'AZN', symbol: '₼ ' },
    'BS': { code: 'BSD', symbol: 'B$ ' },
    'BH': { code: 'BHD', symbol: 'BHD ' },
    'BD': { code: 'BDT', symbol: '৳ ' },
    'BB': { code: 'BBD', symbol: 'Bds$ ' },
    'BY': { code: 'BYN', symbol: 'Br ' },
    'BE': { code: 'EUR', symbol: '€' },
    'BZ': { code: 'BZD', symbol: 'BZ$ ' },
    'BJ': { code: 'XOF', symbol: 'CFA ' },
    'BT': { code: 'BTN', symbol: 'Nu. ' },
    'BO': { code: 'BOB', symbol: 'Bs. ' },
    'BA': { code: 'BAM', symbol: 'KM ' },
    'BW': { code: 'BWP', symbol: 'P ' },
    'BR': { code: 'BRL', symbol: 'R$ ' },
    'BN': { code: 'BND', symbol: 'B$ ' },
    'BG': { code: 'BGN', symbol: 'лв ' },
    'BF': { code: 'XOF', symbol: 'CFA ' },
    'BI': { code: 'BIF', symbol: 'FBu ' },
    'KH': { code: 'KHR', symbol: '៛ ' },
    'CM': { code: 'XAF', symbol: 'FCFA ' },
    'CA': { code: 'CAD', symbol: 'C$ ' },
    'CV': { code: 'CVE', symbol: '$ ' },
    'KY': { code: 'KYD', symbol: 'CI$ ' },
    'CL': { code: 'CLP', symbol: '$ ' },
    'CN': { code: 'CNY', symbol: '¥ ' },
    'CO': { code: 'COP', symbol: '$ ' },
    'CR': { code: 'CRC', symbol: '₡ ' },
    'HR': { code: 'EUR', symbol: '€' },
    'CY': { code: 'EUR', symbol: '€' },
    'CZ': { code: 'CZK', symbol: 'Kč ' },
    'DK': { code: 'DKK', symbol: 'kr ' },
    'DJ': { code: 'DJF', symbol: 'Fdj ' },
    'DO': { code: 'DOP', symbol: 'RD$ ' },
    'EC': { code: 'USD', symbol: '$' },
    'EG': { code: 'EGP', symbol: 'EGP ' },
    'SV': { code: 'USD', symbol: '$' },
    'EE': { code: 'EUR', symbol: '€' },
    'ET': { code: 'ETB', symbol: 'Br ' },
    'FJ': { code: 'FJD', symbol: 'FJ$ ' },
    'FI': { code: 'EUR', symbol: '€' },
    'FR': { code: 'EUR', symbol: '€' },
    'GA': { code: 'XAF', symbol: 'FCFA ' },
    'GM': { code: 'GMD', symbol: 'D ' },
    'GE': { code: 'GEL', symbol: '₾ ' },
    'DE': { code: 'EUR', symbol: '€' },
    'GH': { code: 'GHS', symbol: 'GH₵ ' },
    'GR': { code: 'EUR', symbol: '€' },
    'GD': { code: 'XCD', symbol: 'EC$ ' },
    'GT': { code: 'GTQ', symbol: 'Q ' },
    'GN': { code: 'GNF', symbol: 'FG ' },
    'GY': { code: 'GYD', symbol: 'G$ ' },
    'HT': { code: 'HTG', symbol: 'G ' },
    'HN': { code: 'HNL', symbol: 'L ' },
    'HK': { code: 'HKD', symbol: 'HK$ ' },
    'HU': { code: 'HUF', symbol: 'Ft ' },
    'IS': { code: 'ISK', symbol: 'kr ' },
    'IN': { code: 'INR', symbol: '₹ ' },
    'ID': { code: 'IDR', symbol: 'Rp ' },
    'IQ': { code: 'IQD', symbol: 'IQD ' },
    'IE': { code: 'EUR', symbol: '€' },
    'IL': { code: 'ILS', symbol: '₪ ' },
    'IT': { code: 'EUR', symbol: '€' },
    'JM': { code: 'JMD', symbol: 'J$ ' },
    'JP': { code: 'JPY', symbol: '¥ ' },
    'JO': { code: 'JOD', symbol: 'JOD ' },
    'KZ': { code: 'KZT', symbol: '₸ ' },
    'KE': { code: 'KES', symbol: 'KSh ' },
    'KR': { code: 'KRW', symbol: '₩ ' },
    'KW': { code: 'KWD', symbol: 'KWD ' },
    'KG': { code: 'KGS', symbol: 'с ' },
    'LA': { code: 'LAK', symbol: '₭ ' },
    'LV': { code: 'EUR', symbol: '€' },
    'LB': { code: 'LBP', symbol: 'L£ ' },
    'LS': { code: 'LSL', symbol: 'L ' },
    'LR': { code: 'LRD', symbol: 'L$ ' },
    'LY': { code: 'LYD', symbol: 'LD ' },
    'LI': { code: 'CHF', symbol: 'CHF ' },
    'LT': { code: 'EUR', symbol: '€' },
    'LU': { code: 'EUR', symbol: '€' },
    'MO': { code: 'MOP', symbol: 'MOP$ ' },
    'MK': { code: 'MKD', symbol: 'ден ' },
    'MG': { code: 'MGA', symbol: 'Ar ' },
    'MW': { code: 'MWK', symbol: 'MK ' },
    'MY': { code: 'MYR', symbol: 'RM ' },
    'MV': { code: 'MVR', symbol: 'Rf ' },
    'ML': { code: 'XOF', symbol: 'CFA ' },
    'MT': { code: 'EUR', symbol: '€' },
    'MR': { code: 'MRU', symbol: 'UM ' },
    'MU': { code: 'MUR', symbol: '₨ ' },
    'MX': { code: 'MXN', symbol: 'Mex$ ' },
    'MD': { code: 'MDL', symbol: 'L ' },
    'MC': { code: 'EUR', symbol: '€' },
    'MN': { code: 'MNT', symbol: '₮ ' },
    'ME': { code: 'EUR', symbol: '€' },
    'MA': { code: 'MAD', symbol: 'MAD ' },
    'MZ': { code: 'MZN', symbol: 'MT ' },
    'MM': { code: 'MMK', symbol: 'K ' },
    'NA': { code: 'NAD', symbol: 'N$ ' },
    'NP': { code: 'NPR', symbol: 'रू ' },
    'NL': { code: 'EUR', symbol: '€' },
    'NZ': { code: 'NZD', symbol: 'NZ$ ' },
    'NI': { code: 'NIO', symbol: 'C$ ' },
    'NE': { code: 'XOF', symbol: 'CFA ' },
    'NG': { code: 'NGN', symbol: '₦ ' },
    'NO': { code: 'NOK', symbol: 'kr ' },
    'OM': { code: 'OMR', symbol: 'OMR ' },
    'PA': { code: 'PAB', symbol: 'B/. ' },
    'PG': { code: 'PGK', symbol: 'K ' },
    'PY': { code: 'PYG', symbol: '₲ ' },
    'PE': { code: 'PEN', symbol: 'S/. ' },
    'PH': { code: 'PHP', symbol: '₱ ' },
    'PL': { code: 'PLN', symbol: 'zł ' },
    'PT': { code: 'EUR', symbol: '€' },
    'QA': { code: 'QAR', symbol: 'QR ' },
    'RO': { code: 'RON', symbol: 'lei ' },
    'RU': { code: 'RUB', symbol: '₽ ' },
    'RW': { code: 'RWF', symbol: 'FRw ' },
    'SA': { code: 'SAR', symbol: 'SR ' },
    'SN': { code: 'XOF', symbol: 'CFA ' },
    'RS': { code: 'RSD', symbol: 'din. ' },
    'SG': { code: 'SGD', symbol: 'S$ ' },
    'SK': { code: 'EUR', symbol: '€' },
    'SI': { code: 'EUR', symbol: '€' },
    'ZA': { code: 'ZAR', symbol: 'R ' },
    'ES': { code: 'EUR', symbol: '€' },
    'LK': { code: 'LKR', symbol: 'Rs ' },
    'SE': { code: 'SEK', symbol: 'kr ' },
    'CH': { code: 'CHF', symbol: 'CHF ' },
    'TW': { code: 'TWD', symbol: 'NT$ ' },
    'TZ': { code: 'TZS', symbol: 'TSh ' },
    'TH': { code: 'THB', symbol: '฿ ' },
    'TT': { code: 'TTD', symbol: 'TT$ ' },
    'TN': { code: 'TND', symbol: 'DT ' },
    'TR': { code: 'TRY', symbol: '₺ ' },
    'UG': { code: 'UGX', symbol: 'USh ' },
    'UA': { code: 'UAH', symbol: '₴ ' },
    'AE': { code: 'AED', symbol: 'AED ' },
    'UY': { code: 'UYU', symbol: '$U ' },
    'UZ': { code: 'UZS', symbol: 'so\'m ' },
    'VN': { code: 'VND', symbol: '₫ ' },
    'ZM': { code: 'ZMW', symbol: 'ZK ' },
    'ZW': { code: 'ZWG', symbol: 'ZiG ' }
  };

  var FALLBACK_RATES = {
    'PKR': 1.0,
    'USD': 0.0036,
    'GBP': 0.0028,
    'AFN': 0.25,
    'EUR': 0.0033,
    'CAD': 0.0049,
    'AUD': 0.0055,
    'AED': 0.0132,
    'SAR': 0.0135,
    'QAR': 0.0131,
    'SGD': 0.0048,
    'JPY': 0.54,
    'TRY': 0.12,
    'OMR': 0.0014,
    'KWD': 0.0011,
    'BHD': 0.00135,
    'INR': 0.30,
    'BDT': 0.42,
    'EGP': 0.17,
    'ZAR': 0.065,
    'NZD': 0.0060,
    'SEK': 0.038,
    'NOK': 0.039,
    'MYR': 0.016,
    'MXN': 0.065,
    'BRL': 0.020
  };

  var rates = FALLBACK_RATES;
  var activeCountry = 'PK';
  var activeCurrency = COUNTRY_CURRENCY_MAP['PK'];

  // Load cached rates from localStorage for zero-latency startup
  try {
    var cachedRates = localStorage.getItem(RATES_CACHE_KEY);
    var cachedTime = localStorage.getItem(RATES_CACHE_TIME_KEY);
    if (cachedRates && cachedTime && (Date.now() - parseInt(cachedTime, 10) < CACHE_TTL_MS)) {
      rates = JSON.parse(cachedRates);
    }
  } catch (e) {}

  // Initialize active country from localStorage
  try {
    var stored = localStorage.getItem(STORAGE_KEY);
    if (stored && COUNTRY_CURRENCY_MAP[stored]) {
      activeCountry = stored;
      activeCurrency = COUNTRY_CURRENCY_MAP[stored];
    } else {
      var input = document.querySelector('input[name="country_code"]');
      if (input && input.value && COUNTRY_CURRENCY_MAP[input.value]) {
        activeCountry = input.value;
        activeCurrency = COUNTRY_CURRENCY_MAP[input.value];
        localStorage.setItem(STORAGE_KEY, activeCountry);
      }
    }
  } catch (e) {}

  // Fetch live exchange rates in background and update cache
  function fetchRates() {
    fetch('https://open.er-api.com/v6/latest/PKR')
      .then(function (res) { return res.json(); })
      .then(function (data) {
        if (data && data.result === 'success' && data.rates) {
          rates = data.rates;
          try {
            localStorage.setItem(RATES_CACHE_KEY, JSON.stringify(rates));
            localStorage.setItem(RATES_CACHE_TIME_KEY, Date.now().toString());
          } catch (e) {}
          convertPrices();
        }
      })
      .catch(function (err) {
        console.warn('Using fast cached exchange rates.', err);
      });
  }

  // Convert a single PKR price (in cents) to active currency
  function convertPriceValue(pkrCents) {
    var pkrRupees = pkrCents / 100;
    var rate = rates[activeCurrency.code] || FALLBACK_RATES[activeCurrency.code] || 1.0;
    return pkrRupees * rate;
  }

  // Format currency value
  function formatCurrency(val) {
    if (activeCurrency.code === 'PKR') {
      return activeCurrency.symbol + Math.round(val).toLocaleString();
    }
    return activeCurrency.symbol + val.toLocaleString(undefined, {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2
    });
  }

  // Universal Convert all prices on the page instantly
  function convertPrices() {
    // 1. Convert elements with explicit data-base-price (cents)
    var priceElements = document.querySelectorAll('.vault-price[data-base-price]');
    for (var i = 0; i < priceElements.length; i++) {
      var el = priceElements[i];
      var baseCents = parseInt(el.getAttribute('data-base-price'), 10);
      if (!isNaN(baseCents)) {
        var converted = convertPriceValue(baseCents);
        el.innerHTML = formatCurrency(converted);
      }
    }

    // 2. Convert price ranges (min/max)
    var rangeElements = document.querySelectorAll('.vault-price-range[data-base-price-min][data-base-price-max]');
    for (var j = 0; j < rangeElements.length; j++) {
      var elRange = rangeElements[j];
      var minCents = parseInt(elRange.getAttribute('data-base-price-min'), 10);
      var maxCents = parseInt(elRange.getAttribute('data-base-price-max'), 10);
      if (!isNaN(minCents) && !isNaN(maxCents)) {
        var minConverted = convertPriceValue(minCents);
        var maxConverted = convertPriceValue(maxCents);
        elRange.innerHTML = formatCurrency(minConverted) + ' - ' + formatCurrency(maxConverted);
      }
    }

    // 3. Convert Cart Drawer & Cart Page price elements
    var cartSelectors = [
      '.cart-drawer .price',
      '.cart-drawer .cart-item__price',
      '.cart-drawer .totals__subtotal-value',
      '.cart-drawer .cart-item__final-price',
      '.cart-item__price',
      '.cart-item__final-price',
      '.totals__subtotal-value',
      '.cart-drawer__footer .totals__subtotal-value',
      '.cart-drawer__footer p',
      '.cart-item__totals .price',
      '.price--end'
    ];

    var cartNodes = document.querySelectorAll(cartSelectors.join(','));
    for (var c = 0; c < cartNodes.length; c++) {
      var cNode = cartNodes[c];
      var rawText = cNode.textContent || '';
      if (!cNode.hasAttribute('data-pkr-cents')) {
        var numMatch = rawText.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
        if (numMatch && numMatch[1]) {
          var numVal = parseFloat(numMatch[1]);
          if (numVal > 0) {
            cNode.setAttribute('data-pkr-cents', Math.round(numVal * 100).toString());
          }
        }
      }

      var storedCents = parseInt(cNode.getAttribute('data-pkr-cents'), 10);
      if (!isNaN(storedCents) && storedCents > 0) {
        var convertedVal = convertPriceValue(storedCents);
        cNode.innerHTML = formatCurrency(convertedVal);
      }
    }

    // 4. Convert Price Filter Dropdown (Collection Facets)
    var priceFacetLabels = document.querySelectorAll('.price-facet__label');
    for (var fl = 0; fl < priceFacetLabels.length; fl++) {
      priceFacetLabels[fl].textContent = activeCurrency.symbol.trim();
    }

    var priceFacetHighest = document.querySelectorAll('.price-facet__highest-price');
    for (var fh = 0; fh < priceFacetHighest.length; fh++) {
      var fhNode = priceFacetHighest[fh];
      if (!fhNode.hasAttribute('data-base-pkr')) {
        var match = fhNode.textContent.replace(/,/g, '').match(/(\d+(?:\.\d+)?)/);
        if (match && match[1]) {
          fhNode.setAttribute('data-base-pkr', match[1]);
        }
      }
      var basePkr = parseFloat(fhNode.getAttribute('data-base-pkr'));
      if (!isNaN(basePkr)) {
        var convMax = convertPriceValue(Math.round(basePkr * 100));
        fhNode.textContent = 'The highest price is ' + formatCurrency(convMax);
      }
    }
  }

  // Dynamic Country Messaging (COD vs International Card Payments)
  function updateCountrySpecificText() {
    var isPakistan = (activeCountry === 'PK');

    // Always update body attribute for CSS targeting
    if (document.body) {
      document.body.setAttribute('data-country', activeCountry);
    }

    // 1. Marquee Ticker
    var marqueeElements = document.querySelectorAll('.marquee__repeated-items p');
    for (var i = 0; i < marqueeElements.length; i++) {
      var p = marqueeElements[i];
      if (isPakistan) {
        p.innerHTML = '⚡ TECH THAT FEELS LIKE A VAULT-KEPT SECRET &nbsp;&nbsp;•&nbsp;&nbsp; 💵 CASH ON DELIVERY NATIONWIDE &nbsp;&nbsp;•&nbsp;&nbsp; 🚚 3-5 DAYS DELIVERED VIA TRAX/LEOPARDS &nbsp;&nbsp;•&nbsp;&nbsp; 🔄 30-DAY RETURN POLICY &nbsp;&nbsp;•&nbsp;&nbsp;';
      } else {
        p.innerHTML = '⚡ TECH THAT FEELS LIKE A VAULT-KEPT SECRET &nbsp;&nbsp;•&nbsp;&nbsp; 💳 SECURE CARD CHECKOUT &nbsp;&nbsp;•&nbsp;&nbsp; ✈️ GLOBAL AIR EXPRESS (7-14 DAYS) &nbsp;&nbsp;•&nbsp;&nbsp; 🔄 30-DAY REFUND GUARANTEE &nbsp;&nbsp;•&nbsp;&nbsp;';
      }
    }

    // 2. Top Announcement Bar (Targeting all container levels)
    var announcementItems = document.querySelectorAll('.header-announcements p, .header-announcements span, .header-announcements strong, .header-announcements div');
    for (var j = 0; j < announcementItems.length; j++) {
      var ann = announcementItems[j];
      if (ann.innerHTML && (ann.innerHTML.indexOf('CASH ON DELIVERY') !== -1 || ann.innerHTML.indexOf('SECURE') !== -1)) {
        if (isPakistan) {
          ann.innerHTML = '⚡ <strong>CASH ON DELIVERY AVAILABLE NATIONWIDE</strong>';
        } else {
          ann.innerHTML = '💳 <strong>SECURE INTERNATIONAL CARD PAYMENTS</strong>';
        }
      }
    }

    // 3. Product Page Trust Badges Toggle
    var intlTrust = document.querySelector('.vault-trust-international');
    var localTrust = document.querySelector('.vault-trust-local');
    if (intlTrust && localTrust) {
      if (isPakistan) {
        intlTrust.style.display = 'none';
        localTrust.style.display = 'flex';
      } else {
        intlTrust.style.display = 'flex';
        localTrust.style.display = 'none';
      }
    }
  }

  // Floating Currency Selector Modal Controller
  function initVaultCurrencyModal() {
    var modalWrap = document.getElementById('vaultCurrencyModal');
    if (!modalWrap) return;

    var closeBtn = document.getElementById('vaultModalClose');
    var confirmBtn = document.getElementById('vaultModalConfirm');
    var gridContainer = document.getElementById('vaultCurrencyGrid');

    // Populate all 155+ countries dynamically if dataset exists
    if (gridContainer && typeof VAULT_ALL_COUNTRIES !== 'undefined' && VAULT_ALL_COUNTRIES.length) {
      gridContainer.innerHTML = '';
      for (var idx = 0; idx < VAULT_ALL_COUNTRIES.length; idx++) {
        var item = VAULT_ALL_COUNTRIES[idx];
        var btn = document.createElement('button');
        btn.type = 'button';
        btn.className = 'vault-currency-pill' + (item.code === activeCountry ? ' active' : '');
        btn.setAttribute('data-country-code', item.code);
        btn.setAttribute('data-currency-code', item.currency);
        btn.setAttribute('data-country-name', (item.name + ' ' + item.currency + ' ' + item.symbol + ' ' + item.code).toLowerCase());

        btn.innerHTML = '<span class="vault-flag">' + item.flag + '</span>' +
          '<div class="vault-pill-text">' +
            '<strong class="vault-curr-code">' + item.name + ' (' + item.currency + ' - ' + item.symbol.trim() + ')</strong>' +
            '<span class="vault-curr-note">' + item.note + '</span>' +
          '</div>';

        gridContainer.appendChild(btn);
      }
    }

    var pills = modalWrap.querySelectorAll('.vault-currency-pill');

    // Sync active state in modal grid
    function updateModalPillsState() {
      for (var i = 0; i < pills.length; i++) {
        var pill = pills[i];
        var code = pill.getAttribute('data-country-code');
        if (code === activeCountry) {
          pill.classList.add('active');
        } else {
          pill.classList.remove('active');
        }
      }
    }

    updateModalPillsState();

    // Live search input filtering
    var searchInput = document.getElementById('vaultCountrySearch');
    if (searchInput) {
      searchInput.addEventListener('input', function () {
        var query = (searchInput.value || '').toLowerCase().trim();
        for (var k = 0; k < pills.length; k++) {
          var pill = pills[k];
          var nameAttr = (pill.getAttribute('data-country-name') || '').toLowerCase();
          var text = pill.textContent.toLowerCase();
          if (query === '' || nameAttr.indexOf(query) !== -1 || text.indexOf(query) !== -1) {
            pill.style.display = 'flex';
          } else {
            pill.style.display = 'none';
          }
        }
      });
    }

    // Show modal only if not previously dismissed
    try {
      var dismissed = localStorage.getItem('vault:modal_dismissed');
      if (!dismissed) {
        setTimeout(function () {
          modalWrap.style.display = 'block';
        }, 1200);
      }
    } catch (e) {}

    // Modal Close & Dismiss
    function closeModal() {
      modalWrap.style.display = 'none';
      try {
        localStorage.setItem('vault:modal_dismissed', '1');
      } catch (e) {}
    }

    if (closeBtn) closeBtn.addEventListener('click', closeModal);
    if (confirmBtn) confirmBtn.addEventListener('click', closeModal);

    // Open modal when clicking desktop or mobile drawer currency buttons
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.dropdown-localization__button, .drawer-localization__button, #HeaderDrawer-localization, [data-testid="localization-currency-code"], .dropdown-localization, .drawer-localization');
      if (btn) {
        e.preventDefault();
        e.stopPropagation();
        if (typeof e.stopImmediatePropagation === 'function') e.stopImmediatePropagation();
        modalWrap.style.display = 'block';
        if (searchInput) searchInput.focus();
      }
    }, true);

    // Click on currency pill inside modal
    for (var j = 0; j < pills.length; j++) {
      (function (p) {
        p.addEventListener('click', function () {
          var countryCode = p.getAttribute('data-country-code');
          if (COUNTRY_CURRENCY_MAP[countryCode]) {
            activeCountry = countryCode;
            activeCurrency = COUNTRY_CURRENCY_MAP[countryCode];

            try {
              localStorage.setItem(STORAGE_KEY, activeCountry);
            } catch (e) {}

            // Send background AJAX localization sync to Shopify
            try {
              var formData = new FormData();
              formData.append('country_code', countryCode);
              if (activeCurrency && activeCurrency.code) {
                formData.append('currency_code', activeCurrency.code);
              }
              fetch('/localization', {
                method: 'POST',
                body: formData,
                headers: { 'X-Requested-With': 'XMLHttpRequest' }
              });
            } catch (e) {}

            updateModalPillsState();
            updateSelectorUI();
            updateCountrySpecificText();
            convertPrices();

            // Find matching item in Shopify native header localization menu & trigger native submit
            var nativeItem = document.querySelector('.localization-form__list-item[data-value="' + countryCode + '"]');
            if (nativeItem) {
              var link = nativeItem.querySelector('a, button') || nativeItem;
              link.click();
            } else {
              // Fallback: map international countries to primary international market (US) so all CJ/DSers international products are buyable
              var targetMarketCode = (countryCode === 'PK') ? 'PK' : 'US';
              var marketItem = document.querySelector('.localization-form__list-item[data-value="' + targetMarketCode + '"]');
              if (marketItem) {
                var mLink = marketItem.querySelector('a, button') || marketItem;
                mLink.click();
              } else {
                var form = document.querySelector('form[action*="localization"]');
                if (form) {
                  var hiddenInput = form.querySelector('input[name="country_code"]');
                  if (hiddenInput) hiddenInput.value = targetMarketCode;
                  form.submit();
                }
              }
            }

            closeModal();
          }
        });
      })(pills[j]);
    }
  }

  // Update header selector button and selector dropdown active states
  function updateSelectorUI() {
    // Update active currency code text in all trigger buttons
    var codeElements = document.querySelectorAll('.currency-code[data-testid="localization-currency-code"]');
    for (var i = 0; i < codeElements.length; i++) {
      codeElements[i].textContent = '🌐 Choose Currency (' + activeCurrency.code + ' ' + activeCurrency.symbol.trim() + ')';
    }

    // Update flag icon in trigger buttons
    var flagElements = document.querySelectorAll('.dropdown-localization__button .icon-flag');
    for (var j = 0; j < flagElements.length; j++) {
      flagElements[j].style.backgroundImage = 'url(https://flagcdn.com/w40/' + activeCountry.toLowerCase() + '.png)';
    }

    // Ensure hidden inputs are updated
    var inputs = document.querySelectorAll('input[name="country_code"]');
    for (var k = 0; k < inputs.length; k++) {
      inputs[k].value = activeCountry;
    }

    // Update checkmarks and current styling in dropdown list
    var listItems = document.querySelectorAll('.localization-form__list-item[data-value]');
    for (var m = 0; m < listItems.length; m++) {
      var item = listItems[m];
      if (item.getAttribute('data-value') === activeCountry) {
        item.setAttribute('aria-current', 'true');
        var checkmark = item.querySelector('.svg-wrapper.icon-checkmark');
        if (checkmark) checkmark.style.visibility = 'visible';
      } else {
        item.removeAttribute('aria-current');
        var checkmark = item.querySelector('.svg-wrapper.icon-checkmark');
        if (checkmark) checkmark.style.visibility = 'hidden';
      }
    }
  }

  // Intercept selection in localization lists & ELIMINATE FULL PAGE RELOAD LATENCY
  document.addEventListener('click', function (event) {
    var target = event.target;
    if (!target || !target.closest) return;

    var item = target.closest('.localization-form__list-item[data-value], [name="country_code"]');
    if (!item) return;

    // Prevent default form submit & full page reload latency!
    event.preventDefault();
    event.stopPropagation();

    var selectedVal = item.getAttribute('data-value') || item.value;
    if (COUNTRY_CURRENCY_MAP[selectedVal]) {
      try {
        localStorage.setItem(STORAGE_KEY, selectedVal);
      } catch (e) {}

      activeCountry = selectedVal;
      activeCurrency = COUNTRY_CURRENCY_MAP[selectedVal];

      // Sync active currency & country to Shopify native checkout session
      try {
        var formData = new FormData();
        formData.append('country_code', selectedVal);
        if (activeCurrency && activeCurrency.code) {
          formData.append('currency_code', activeCurrency.code);
        }
        fetch('/localization', {
          method: 'POST',
          body: formData,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        });
      } catch (e) {}

      // Perform instant zero-latency UI & price updates
      updateSelectorUI();
      updateCountrySpecificText();
      convertPrices();

      // Instantly close open dropdown menu
      var disclosure = target.closest('details, .disclosure, header-localization, localization-form');
      if (disclosure) {
        if (disclosure.tagName === 'DETAILS') {
          disclosure.removeAttribute('open');
        } else {
          var detailsParent = disclosure.querySelector('details');
          if (detailsParent) detailsParent.removeAttribute('open');
        }
      }
    }
  }, true);



  // Setup DOM MutationObserver to catch dynamically added elements
  var observer = new MutationObserver(function (mutations) {
    var shouldConvert = false;
    for (var i = 0; i < mutations.length; i++) {
      var mutation = mutations[i];
      if (mutation.type === 'childList') {
        for (var j = 0; j < mutation.addedNodes.length; j++) {
          var node = mutation.addedNodes[j];
          if (node.nodeType === 1) {
            if (node.classList.contains('vault-price') || node.classList.contains('vault-price-range') || node.querySelector('.vault-price, .vault-price-range')) {
              shouldConvert = true;
              break;
            }
          }
        }
      } else if (mutation.type === 'attributes' && (mutation.attributeName === 'data-base-price' || mutation.attributeName === 'data-base-price-min')) {
        shouldConvert = true;
        break;
      }
    }

    if (shouldConvert) {
      convertPrices();
      updateCountrySpecificText();
    }
  });

  // Run initial updates instantly
  function init() {
    updateSelectorUI();
    updateCountrySpecificText();
    convertPrices();
    fetchRates();
    initVaultCurrencyModal();

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['data-base-price', 'data-base-price-min']
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();

